import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function RegenerativeDifference() {
  return <section className="py-20 md:py-32 bg-cream-dark/20 border-t border-divider" data-id="element-192">
      <div className="container mx-auto px-4 md:px-6" data-id="element-193">
        <div className="max-w-4xl mx-auto text-center" data-id="element-194">
          <FadeIn data-id="element-195">
            <span className="inline-block font-sans font-semibold text-jade tracking-[0.2em] uppercase text-xs md:text-sm mb-6" data-id="element-196">
              Nourishment, Not Alteration
            </span>
          </FadeIn>

          <FadeIn delay={200} data-id="element-197">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-primary mb-8" data-id="element-198">
              We feed your skin. Your skin does the rest.
            </h2>
          </FadeIn>

          <FadeIn delay={400} data-id="element-199">
            <p className="text-base md:text-lg text-foreground/80 leading-relaxed mb-12 max-w-3xl mx-auto" data-id="element-200">
              Korean Mesotherapy isn't about changing your face — it's about
              giving your skin the nutrients it's been depleted of.
              Microinjections deliver a custom blend of hyaluronic acid,
              vitamins, and peptides directly into the mesoderm — the living
              layer where real change happens. No filler. No volume added. No
              frozen expressions. Just your skin, deeply nourished and
              responding beautifully.
            </p>
          </FadeIn>

          <FadeIn delay={600} data-id="element-201">
            <div className="inline-flex flex-wrap justify-center items-center gap-2 md:gap-4 px-6 py-3 bg-white border border-divider rounded-full text-sm font-medium text-primary shadow-sm" data-id="element-202">
              <span data-id="element-203">No Filler</span>
              <span className="text-gold" data-id="element-204">•</span>
              <span data-id="element-205">No Volume Added</span>
              <span className="text-gold" data-id="element-206">•</span>
              <span data-id="element-207">Pure Cellular Nutrition</span>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}